import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './WidthContainerCompensator.scss'


const WidthContainerCompensator = ({ className, children }) => (
  <div className={cx(s.widthContainerCompensator, className)}>
    {children}
  </div>
)

WidthContainerCompensator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}


export default WidthContainerCompensator
